import Vue from 'vue';

import FormRender from './FormRender/index.vue';
import UE from './UE/index.vue';
import VueEditor from './VueEditor/index.vue';


Vue.component('pur-form-render', FormRender);
Vue.component('vue-editor', VueEditor);
// Vue.component('ue', UE);



// WEBPACK FOOTER //
// ./src/views/Component/index.js